import { render, staticRenderFns } from "./DirectRentPage.vue?vue&type=template&id=564ff318&scoped=true&"
import script from "./DirectRentPage.vue?vue&type=script&lang=js&"
export * from "./DirectRentPage.vue?vue&type=script&lang=js&"
import style0 from "./DirectRentPage.vue?vue&type=style&index=0&id=564ff318&lang=scss&scoped=true&"
import style1 from "./DirectRentPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ff318",
  null
  
)

export default component.exports